export default "__VITE_ASSET__I5pQwQm8__"